// import { useState, useEffect } from "react";
// import { useGetFileMutation } from "../../api/vmsSlice";
// import { PopOver } from ".";

// const FilePreview = ({ fileKey, extension }) => {
// 	const [getFile] = useGetFileMutation();
// 	const [fileData, setFileData] = useState(null);
// 	const [popoverOpen, setPopoverOpen] = useState(false);
// 	const [anchorEl, setAnchorEl] = useState(null);
// 	const base64ToBlobUrl = (base64, type = "application/pdf") => {
// 		const binary = atob(base64);
// 		const array = Uint8Array.from(binary, char => char.charCodeAt(0));
// 		const blob = new Blob([array], { type });
// 		return URL.createObjectURL(blob);
// 	  };
// 	const fetcFileByKey = async (fileKey) => {
// 		try {
// 			const response = await getFile({ fileKey });
// 			if (response?.data?.data) {
// 				setFileData(response.data.data);
// 			}
// 		} catch (error) {
// 			console.error("Failed to fetch file:", error);
// 		}
// 	};
// 	const blobUrl = base64ToBlobUrl(fileData);
// 	console.log(blobUrl)
// 	useEffect(() => {
// 		if (!fileKey) return;
// 		fetcFileByKey(fileKey);
// 	}, [fileKey]);

// 	const handleClick = (e) => {
// 		setAnchorEl(e.currentTarget);
// 		setPopoverOpen(true);
// 	};

// 	const handleClose = () => {
// 		setPopoverOpen(false);
// 	};

// 	if (!fileKey || !fileData) return null;
// 	return (
// 		<>
// 			{extension === "pdf" ? (
// 				<>
// 					<div
// 						style={{ position: "relative", width: "100px", height: "100px", cursor: "pointer", overflow: "hidden", border: "1px solid var(--primary-color)", borderRadius: "2px" }}
// 						onClick={handleClick}
// 					>
// 						<object
// 							// data={`data:application/pdf;base64,${fileData}`}
// 							data={blobUrl}
// 							type="application/pdf"
// 							width="100%"
// 							height="100%"
// 							style={{
// 								width: "110px",
// 								height: "110px",
// 							}}
// 						/>
// 						<div //This div is to make the object tag clickable as clicking on object tag do not works in the case of embedded PDF viewer
// 							style={{
// 								position: "absolute",
// 								top: 0,
// 								left: 0,
// 								width: "100%",
// 								height: "100%",
// 								zIndex: 1,
// 								display:'flex',
// 								justifyContent:'center',
// 								alignItems:'center',
// 								textAlign:'center',
// 								backgroundColor:'#dcdcdc'
								
// 							}}
// 						>Click here to preview PDF</div>
// 					</div>
// 					<PopOver open={popoverOpen} anchorEl={anchorEl} onClose={handleClose} title={"PDF Preview"} width={"40vw"} height={"95vh"}>
// 						<object
// 							// data={`data:application/pdf;base64,${fileData}`}
// 							data={blobUrl} 
// 							type="application/pdf"
// 							width="auto"
// 							height="inherit"
// 							style={{
// 								width: "100%",
// 								height: "100%",
// 							}}
// 						></object>
// 					</PopOver>
// 				</>
// 			) : (
// 				<>
// 					<img
// 						src={`data:image/jpeg;base64,${fileData}`}
// 						style={{
// 							maxWidth: "100px",
// 							maxHeight: "100px",
// 							cursor: "pointer",
// 						}}
// 						onClick={handleClick}
// 					/>

// 					<PopOver open={popoverOpen} anchorEl={anchorEl} onClose={handleClose} title={"Image Preview"}>
// 						<img
// 							src={`data:image/jpeg;base64,${fileData}`}
// 							style={{
// 								maxWidth: "40vw",
// 								maxHeight: "40vh",
// 								display: "block",
// 							}}
// 						/>
// 					</PopOver>
// 				</>
// 			)}
// 		</>
// 	);
// };

// export default FilePreview;





import { useState, useEffect, useRef, useCallback } from "react";
import { useGetFileMutation } from "../../api/vmsSlice";
import { PopOver } from ".";
import { IconButton, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DownloadIcon from "@mui/icons-material/Download";

const MIN_ZOOM = 0.5;
const MAX_ZOOM = 3;
const ZOOM_STEP = 0.2;

const FilePreview = ({ fileKey, extension }) => {
	const [getFile] = useGetFileMutation();
	const [fileData, setFileData] = useState(null);
	const [popoverOpen, setPopoverOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [zoom, setZoom] = useState(1);
	const [naturalSize, setNaturalSize] = useState(null);
	const imageContainerRef = useRef(null);

	const base64ToBlobUrl = (base64, type = "application/pdf") => {
		const binary = atob(base64);
		const array = Uint8Array.from(binary, char => char.charCodeAt(0));
		const blob = new Blob([array], { type });
		return URL.createObjectURL(blob);
	};

	const fetchFileByKey = async (fileKey) => {
		try {
			const response = await getFile({ fileKey });
			if (response?.data?.data) {
				setFileData(response.data.data);
			}
		} catch (error) {
			console.error("Failed to fetch file:", error);
		}
	};

	useEffect(() => {
		if (!fileKey) return;
		fetchFileByKey(fileKey);
	}, [fileKey]);

	const handleClick = (e) => {
		setAnchorEl(e.currentTarget);
		setPopoverOpen(true);
	};

	const handleClose = () => {
		setPopoverOpen(false);
		setZoom(1);
		setNaturalSize(null);
	};

	const handleImageLoad = (e) => {
		setNaturalSize({ width: e.target.naturalWidth, height: e.target.naturalHeight });
	};

	const handleWheel = useCallback((e) => {
		e.preventDefault();
		setZoom((prev) => {
			const delta = e.deltaY < 0 ? ZOOM_STEP : -ZOOM_STEP;
			return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, prev + delta));
		});
	}, []);

	useEffect(() => {
		const container = imageContainerRef.current;
		if (!container || !popoverOpen || extension === "pdf") return;
		container.addEventListener("wheel", handleWheel, { passive: false });
		return () => container.removeEventListener("wheel", handleWheel);
	}, [popoverOpen, extension, handleWheel]);

	// Scroll to center when zoom changes
	useEffect(() => {
		const container = imageContainerRef.current;
		if (!container || !popoverOpen || extension === "pdf") return;
		const scrollLeft = (container.scrollWidth - container.clientWidth) / 2;
		const scrollTop = (container.scrollHeight - container.clientHeight) / 2;
		container.scrollTo({ left: scrollLeft, top: scrollTop });
	}, [zoom, popoverOpen, extension]);

	if (!fileKey || !fileData) return null;

	const blobUrl = base64ToBlobUrl(fileData);

	return (
		<>
			{extension === "pdf" ? (
				<>
					<div
						style={{
							position: "relative",
							width: "100px",
							height: "100px",
							cursor: "pointer",
							overflow: "hidden",
							border: "1px solid var(--primary-color)",
							borderRadius: "2px",
						}}
						onClick={handleClick}
					>
						<iframe
							src={`data:application/pdf;base64,${fileData}`}
							width="100%"
							height="100%"
							style={{
								pointerEvents: "none",
								border: "none",
								width: "110px",
								height: "110px",
							}}
							title="PDF Preview Thumbnail"
						></iframe>
						<div
							style={{
								position: "absolute",
								top: 0,
								left: 0,
								width: "100%",
								height: "100%",
								zIndex: 1,
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								textAlign: "center",
								backgroundColor: "#dcdcdc",
							}}
						>
							Click here to preview PDF
						</div>
					</div>

					<PopOver
						open={popoverOpen}
						anchorEl={anchorEl}
						onClose={handleClose}
						title={"PDF Preview"}
						width={"40vw"}
						height={"95vh"}
					>
						<iframe
							src={`data:application/pdf;base64,${fileData}`}
							type="application/pdf"
							title="Full PDF Viewer"
							style={{
								width: "100%",
								height: "100%",
								border: "none",
							}}
						></iframe>
					</PopOver>
				</>
			) : (
				<>
					<img
						src={`data:image/jpeg;base64,${fileData}`}
						style={{
							maxWidth: "100px",
							maxHeight: "100px",
							cursor: "pointer",
						}}
						onClick={handleClick}
					/>

					<PopOver
						open={popoverOpen}
						anchorEl={anchorEl}
						onClose={handleClose}
						title={"Image Preview"}
						width={"43vw"}
						height={"60vh"}
					>
						<Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
							<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1, flexShrink: 0 }}>
								<IconButton size="small" onClick={() => setZoom((z) => Math.max(MIN_ZOOM, z - ZOOM_STEP))}>
									<RemoveIcon fontSize="small" />
								</IconButton>
								<span style={{ fontSize: "0.85rem", minWidth: "40px", textAlign: "center" }}>
									{Math.round(zoom * 100)}%
								</span>
								<IconButton size="small" onClick={() => setZoom((z) => Math.min(MAX_ZOOM, z + ZOOM_STEP))}>
									<AddIcon fontSize="small" />
								</IconButton>
								<IconButton size="small" onClick={() => setZoom(1)}>
									<RestartAltIcon fontSize="small" />
								</IconButton>
								<IconButton
									size="small"
									onClick={() => {
										const link = document.createElement("a");
										link.href = `data:image/jpeg;base64,${fileData}`;
										link.download = `${fileKey}.jpeg`;
										link.click();
									}}
								>
									<DownloadIcon fontSize="small" />
								</IconButton>
							</Box>
							<Box
								ref={imageContainerRef}
								sx={{
									flex: 1,
									overflow: "auto",
								}}
							>
								<Box
									sx={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										minWidth: "100%",
										minHeight: "100%",
										boxSizing: "border-box",
										p: 1,
									}}
								>
									<img
										src={`data:image/jpeg;base64,${fileData}`}
										onLoad={handleImageLoad}
										style={{
											display: "block",
											...(naturalSize
												? {
													width: naturalSize.width * zoom,
													height: naturalSize.height * zoom,
													maxWidth: zoom <= 1 ? "100%" : "none",
													maxHeight: zoom <= 1 ? "100%" : "none",
												}
												: {
													maxWidth: "100%",
													maxHeight: "100%",
												}),
											objectFit: "contain",
										}}
										draggable={false}
									/>
								</Box>
							</Box>
						</Box>
					</PopOver>
				</>
			)}
		</>
	);
};

export default FilePreview;
